import React, { useEffect, useState } from 'react';
import '../../css/mediaInfoCard.css';
import { api } from "../../services";

const Item = ({ title, iconUrl, desc }) => {
    return (
        <div className="item-card">
            <div className="item-icon-container">
                {iconUrl && (
                    <img
                        src={iconUrl}
                        alt={title || 'Icon'}
                        className="item-icon"
                    />
                )}
            </div>
            <div className="item-content">
                <h3 className="item-title">{title}</h3>
                <p className="item-desc">{desc}</p>
            </div>
        </div>
    );
};

const MediaInfoCard = ({ data }) => {
    const [items, setItems] = useState([]);

    useEffect(() => {
        const fetchIcons = async () => {
            try {
                const result = await api.general.getItemIcon();
                if (result) {
                    const mediaInfoCardPage = result.data.data[0].attributes?.pages.find(
                        page => page.__component === 'pages-component.media-info-card'
                    );

                    if (mediaInfoCardPage) {
                        const updatedItems = mediaInfoCardPage.item?.map((item) => ({
                            title: item.title,
                            description: item.description,
                            iconUrl: item.icon?.data?.attributes?.url || '',
                        }));
                        setItems(updatedItems);
                    }
                }
            } catch (error) {
                console.error('Error fetching icons:', error);
            }
        };
        fetchIcons();
    }, []);

    return (
        <div>
            <h3 className="card-title-media">{data.title}</h3>
            <div className="media-info-card">
                <div className="media-info-left">
                    <img
                        src={data.media.data.attributes?.url}
                        alt={data.media.data.attributes?.name}
                        className="media-image"
                    />
                </div>
                <div className="media-info-right">
                    {items.map((item, index) => (
                        <Item
                            key={index}
                            title={item.title}
                            iconUrl={item.iconUrl}
                            desc={item.description}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default MediaInfoCard;
